module.exports = __webpack_public_path__ + "static/img/anton-jansson-y32uYxeqjPc-unsplash_thumb.9737cc0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/anton-jansson-y32uYxeqjPc-unsplash_thumb.png
// module id = 8YMP
// module chunks = 4